<section *ngIf="!showSpiner" class="pupil_personal pupilpersonal_bg">
  <div class="container">
    
    <div class="row" *ngIf="lesson">
      <div class="col-4 left-bar" *ngIf="student">
        <app-privilege-icon 
            [student]="student" 
            [lesson]="lesson"
        ></app-privilege-icon>
      </div>

      <div class="col-6">
        <div class="card-number">
          <div class="input-group big active">
            <span class="card-choice-cross-icon" (click)="clearInput()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
                <defs>
                  <style>.pupil_choice-close-cls-1,.pupil_choice-close-cls-2{fill:none;}.pupil_choice-close-cls-2{stroke:#ccc;stroke-miterlimit:10;stroke-width:2px;} .card-choice-cross-icon:hover .pupil_choice-close-cls-2{stroke:#999999;stroke-miterlimit:10;stroke-width:2px;}</style>
                </defs>
                <title></title>
                <g id="Слой_2" data-name="Слой 2">
                  <g id="Слой_10" data-name="Слой 10">
                    <rect class="pupil_choice-close-cls-1" width="32" height="32"/>
                    <line class="pupil_choice-close-cls-2" x1="2" y1="2" x2="30" y2="30"/>
                    <line class="pupil_choice-close-cls-2" x1="2" y1="30" x2="30" y2="2"/></g></g>
              </svg>
            </span>
            <input type="text" name="" class="text-left" [(ngModel)]="cardNumber" readonly="readonly">
            <span class="label">
              Введи номер своего варианта
              <img src="/assets/images/pupil_personal/pupil_personal_bg.png" class="pupil_personal_bg_img" />
            </span>
          </div>
        </div>

        <div class="keyboard">
          <div class="keyboard-container">
            <ul>
              <li class="keyboard-item" *ngFor="let button of buttons">
                <a (click)="buttonClick(button)" appDisTouchmove>
                  {{ button }}
                </a>
              </li>
              <li class="keyboard-item">
                <a (click)="buttonClick(0)" appDisTouchmove>
                  0
                </a>
              </li>
              <li class="keyboard-item enter">
                <a (click)="searchCard()" appDisTouchmove></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <a class="exit" (click)="exitClicked()" appDisTouchmove>
        <span class="txt">Назад</span>
      </a>
    </div>
  </div>
</section>

<!-- Modal Solved Card 1 -->
<div class="modal solved-card-modal fade in" id="solvedcard1" #solvedModal="bs-modal" bsModal [config]="{backdrop: 'static'}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row text-center">
          <div class="top col">
            <h2>{{ modalMessage }}</h2>
          </div>
        </div>
        <div class="row action-options">
          <div class="col go_out text-center">
            <a class="action-options-btn" (click)="exitClicked()" appDisTouchmove>
              <span>Выйти</span>
            </a>
          </div>
          <div class="col picture" *ngIf="!isAbsent">
            <img src="/assets/images/modal/1.jpg" alt="" *ngIf="!cardNotFound">
            <div *ngIf="cardNotFound" style="width: 136px; height: 220px"></div>
          </div>
          <div class="col true_answer text-center" *ngIf="!isAbsent">
            <a class="action-options-btn" (click)="hideModal()" appDisTouchmove>
              <span>Набрать правильный номер</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<section *ngIf="showSpiner" class="spiner">
  <mat-progress-spinner
      class="spinner"
      mode="indeterminate">
  </mat-progress-spinner>
</section>
<!-- Modal window CHECK CARD nukta-gemera -->
<div class="modal check-card-modal fade" id="check_card" #checkModal="bs-modal" bsModal *ngIf="allCardSettings.length">
  <div class="modal-dialog" style="width: 1028px;">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row text-center">
          <div class="top col">
            <h2>Кто тебя проверит?</h2>
          </div>
        </div>
        <div class="row modal-bgr" *ngIf="card">
          <div class="col-5 modal-card" *ngIf="card.box?.check_character">
            <div class="drachma modal-choice-text-blue">
              <p style="font-size: 19px">Если все решено правильно,</p>
              <div *ngIf="allCardSettings[0]?.reward!=0">
                <span>
                  <p><b>я дам тебе</b></p>
                </span>
                <span class="money-circle-blue">{{ allCardSettings[0]?.reward }}</span>
                <span>
                  <p>{{ declensionOfNumerals(allCardSettings[0]?.reward) }}</p>
                </span>
              </div>
              <p *ngIf="allCardSettings[0]?.reward==0"><b>вознаграждения нет</b></p>
            </div>
            <a (click)="selectCharacter(false, card.box.check_character_obj)" *ngIf="card.box.check_character_obj.image; else check_character_btn">
              <img src="{{main_domain}}{{card.box.check_character_obj.image_url}}" 
                alt="{{ card.box.check_character_obj.title }}"
                style="border-radius: 5px; cursor: pointer">
            </a>
            <ng-template #check_character_btn>
              <button (click)="selectCharacter(false, card.box.check_character_obj)" class="btn btn-primary">{{ card.box.check_character_obj.title }}</button>
            </ng-template>
            <div class="drachma modal-choice-text-red">
              <p class="no-penalty"><b>штрафа нет</b></p>
              <p style="font-size: 19px">Если что-то неправильно</p>
            </div>
          </div>
          <div class="col-2 modal-choice-text" 
            *ngIf="card.box?.risk_character && card.box?.check_character">
            <div class="row">
              <span class="modal-choice-left-triangle">&nbsp;</span>
              <span>Выбери</span>
              <span class="modal-choice-right-triangle">&nbsp;</span>
            </div>
          </div>
          <div class="col-5 modal-card" *ngIf="card.box?.risk_character">
            <div class="drachma modal-choice-text-blue">
              <p style="font-size: 19px">Если все решено правильно,</p>
              <div *ngIf="allCardSettings.length && allCardSettings[1]?.reward!=0">
                <span>
                  <p><b>я дам тебе</b></p>
                </span>
                <span class="money-circle-blue">{{ allCardSettings[1]?.reward }}</span>
                <span>
                  <p>{{ declensionOfNumerals(allCardSettings[1]?.reward) }}</p>
                </span>
              </div>
              <p *ngIf="allCardSettings.length && allCardSettings[1]?.reward==0"><b>вознаграждения нет</b></p>
            </div>
            <a (click)="selectCharacter(true, card.box.risk_character_obj)" *ngIf="card.box.risk_character_obj.image; else risk_character_btn">
              <img alt="{{ card.box.risk_character_obj.title }}" 
                src="{{main_domain}}{{card.box.risk_character_obj.image_url}}" 
                style="border-radius: 5px; cursor: pointer">
            </a>
            <ng-template #risk_character_btn>
              <button (click)="selectCharacter(true, card.box.risk_character_obj)" class="btn btn-danger">{{ card.box.risk_character_obj.title }}</button>
            </ng-template>
            <div class="drachma modal-choice-text-red">
              <div class="row" *ngIf="allCardSettings.length && allCardSettings[1]?.penalty!=0 && allCardSettings[1]?.penalty!=1">
                <div class="col-5 left-text">
                  <span><b>штраф</b></span>
                </div>
                <div class="money-circle-red">{{ allCardSettings[1]?.penalty }}</div>
                <div class="col-5 right-text">
                  <span>{{ declensionOfNumerals(allCardSettings[1]?.penalty) }}<br></span>
                </div>
              </div>
              <div class="row" *ngIf="allCardSettings.length && allCardSettings[1]?.penalty==1">
                <div class="col-5 left-text">
                  <span><b>штраф</b></span>
                </div>
                <div class="money-circle-red">{{ allCardSettings[1]?.penalty }}</div>
                <div class="col-5 right-text">
                  <span>{{currencies[0].title}}<br></span>
                </div>
              </div>
              <p *ngIf="allCardSettings.length && allCardSettings[1]?.penalty==0" class="no-penalty"><b>штрафа нет</b></p>
              <p style="font-size: 19px">Если что-то неправильно</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- # -->


<!-- модалка которая уведомляет об ошибки авторизации -->
<ng-template #authorizateonErrorMsg>
  <mat-dialog-content class="error-msg__dialog">
    <p><b>Ошибка авторизации, позави учителя</b></p>
    <p><b>Для учителя:</b></p>
    <p>Попробуйте удалить куки и зайти заново.</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="closeDialog()">Хорошо</button>
  </mat-dialog-actions>
</ng-template>
